import _ from 'lodash';
import autobind from 'autobind-decorator';
import {
	autorun,
	observable,
	action,
	observe,
	computed,
	runInAction,
	reaction,
	extendObservable,
	toJS
} from 'mobx';

import { BaseStore, apiStore, songsStore, userStore } from 'common/stores';
import config from 'client/shared/config';

class StatsStore extends BaseStore {
	userID;

	@observable
	_stats = {};

	constructor () {
		super();

		reaction(() => apiStore.data.stats, this.onNewData);
		this.isLoading = true;
	}

	@computed
	get stats () {
		return this._stats;
	}

	set stats (stats) {
		this._stats = stats;
	}

	@computed
	get mostListenedToSongTitle () {
		return this.stats.mostListenedToSong.title;
	}

	@computed
	get mostHifivedSongTitle () {
		return this.stats.mostHifivedSong.title;
	}

	@action
	async fetchStats () {
		this.isLoading = true;

		try {

			const { data: { stats } } = await this.ax
				.get(config.routes.profile.replace(/\:_id/, userStore.get('user._id')));

			runInAction('Update with fetched stats', () => {
				this.stats = stats;
			});
		} catch (err) {

			console.log('[ERROR StatsStore.fetchStats]', err);
		} finally {

			this.isLoading = false;
		}
	}

	@autobind
	@action
	onNewData (stats) {
		this.stats = stats;
		this.isLoading = false;
	}
}

const statsStore = new StatsStore();
export default statsStore;
